import Cookies from 'universal-cookie';
import { env } from '../config';

const cookies = new Cookies();

export const isProduction = () => env === 'production';

export const isImpersonating = () => cookies.get('sg_impersonate') === 'true';

export const isDevelopment = () => !env || env === 'development';

export const devLog = (...args) => {
  if (!isProduction()) {
    // eslint-disable-next-line
    console.log(...args);
  }
};

export const getStoreForLocal = () => localStorage.getItem('sg_store');

export const setStoreForLocal = (storeId) => {
  localStorage.setItem('sg_store', storeId);
};

export const localLogout = () => {
  localStorage.removeItem('sg_store');
};
